import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c8c83b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uploader-view" }
const _hoisted_2 = {
  key: 0,
  class: "upload-btn"
}
const _hoisted_3 = {
  key: 1,
  class: "upload-btn"
}
const _hoisted_4 = {
  key: 0,
  class: "custom-loading-overlay"
}
const _hoisted_5 = { class: "custom-loading-content" }
const _hoisted_6 = { class: "el-loading-spinner" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "circular",
  viewBox: "25 25 50 50"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "path",
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none"
  })
], -1))
const _hoisted_8 = { class: "custom-loading-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_uploaderDataFilterComponent = _resolveComponent("uploaderDataFilterComponent")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_uploaderDataListComponent = _resolveComponent("uploaderDataListComponent")!
  const _component_uploaderDataListManualComponent = _resolveComponent("uploaderDataListManualComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      style: {"width":"100%"},
      gutter: 10
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { lg: 6 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_uploaderDataFilterComponent, {
                  cleanningType: _ctx.uploadType,
                  onRemove: _ctx.removeData,
                  ref: "filter"
                }, null, 8, ["cleanningType", "onRemove"]),
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("radio.cleaningprocess")) + " ", 1),
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.uploadType,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.uploadType) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, {
                        label: "automatic",
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("radio.automatic")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, {
                        label: "manual",
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("radio.manual")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                (_ctx.uploadType === 'automatic')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            loading: _ctx.loading,
                            type: "primary",
                            class: "btn",
                            size: "large",
                            disabled: _ctx.trainingData.length > 0,
                            round: "",
                            onClick: _ctx.handleSubmit
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("btn.preview")), 1)
                            ]),
                            _: 1
                          }, 8, ["loading", "disabled", "onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            loading: _ctx.loadingUpload,
                            type: "primary",
                            class: "btn",
                            size: "large",
                            disabled: _ctx.trainingData.length <= 0,
                            round: "",
                            onClick: _ctx.uploadData
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("btn.cleanningAndUpload")), 1)
                            ]),
                            _: 1
                          }, 8, ["loading", "disabled", "onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.selectedSamplingPointId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedSamplingPointId) = $event)),
                        size: "large",
                        style: {"width":"90%","margin-top":"5px","margin-bottom":"5px"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.samplingPoints, (sp) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: sp.id,
                              label: `${sp.name}`,
                              value: sp.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            loading: _ctx.loadingUpload,
                            type: "primary",
                            class: "btn",
                            size: "large",
                            disabled: !_ctx.selectedSamplingPointId,
                            round: "",
                            onClick: _ctx.assignImageLabels
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("title.imageLabel")), 1)
                            ]),
                            _: 1
                          }, 8, ["loading", "disabled", "onClick"])
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            loading: _ctx.loading,
                            type: "primary",
                            class: "btn",
                            size: "large",
                            disabled: _ctx.trainingData.length > 0,
                            round: "",
                            onClick: _ctx.handleSubmitManual
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("btn.preview")), 1)
                            ]),
                            _: 1
                          }, 8, ["loading", "disabled", "onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            loading: _ctx.loadingUpload,
                            type: "primary",
                            class: "btn",
                            size: "large",
                            disabled: _ctx.trainingData.length <= 0,
                            round: "",
                            onClick: _ctx.updateData
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("btn.sendCleanning")), 1)
                            ]),
                            _: 1
                          }, 8, ["loading", "disabled", "onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            loading: _ctx.loadingUpload,
                            type: "primary",
                            class: "btn",
                            size: "large",
                            disabled: !_ctx.assingLabels,
                            round: "",
                            onClick: _ctx.assignImageLabels
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("title.imageLabel")), 1)
                            ]),
                            _: 1
                          }, 8, ["loading", "disabled", "onClick"])
                        ]),
                        _: 1
                      })
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { lg: 18 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, null, {
              default: _withCtx(() => [
                (_ctx.uploadType === 'automatic')
                  ? (_openBlock(), _createBlock(_component_uploaderDataListComponent, {
                      key: 0,
                      ref: "list",
                      entities: _ctx.trainingData,
                      form: _ctx.formUpload,
                      onRemove: _ctx.removeData
                    }, null, 8, ["entities", "form", "onRemove"]))
                  : (_openBlock(), _createBlock(_component_uploaderDataListManualComponent, {
                      key: 1,
                      ref: "list",
                      entities: _ctx.trainingData,
                      form: _ctx.formUpload,
                      onRemove: _ctx.removeData
                    }, null, 8, ["entities", "form", "onRemove"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.customLoading.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.customLoading.text), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}